import { render } from 'react-dom'
import { CommentFooter } from '../../Comments/CommentFooter'

document.addEventListener('DOMContentLoaded', () => {
  render(<CommentFooter />, document.getElementById('comment-footer'))
})
